import {VentrataDataProvider} from 'components/common/CartItemBuilder/providers/VentrataDataProvider'
import {size} from 'lodash'
import {Option} from './Option'

export const MaximizedOptions = () => {
  const product = VentrataDataProvider.useProduct('optional')
  const availabilities = VentrataDataProvider.useAvailabilities('optional')

  const availableOptions = product.options.filter((option) => {
    const optionAvailabilities = availabilities[option.id] || []
    return optionAvailabilities.some((availability) => availability.available)
  })

  if (!product.id || size(availabilities) === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      {availableOptions.map((option) => {
        return <Option key={option.id} option={option} />
      })}
    </div>
  )
}
